import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationExtras, Router } from '@angular/router';
import { CarruselClass } from '@core/model/carruselClass.model';
import { CutsProjectModel } from '@core/model/custProject.model';
import { ImageList } from '@core/model/imageList.model';
import { ItemInformationModel } from '@core/model/itemInformation.model';
import { MasterClientModel } from '@core/model/masterClient.model';
import { ProductFamilyModel } from '@core/model/productFamily.model';
import { ProductImageModel } from '@core/model/productImage.model';
import { SendItemModel } from '@core/model/sendItem.model';
import { SiteModel } from '@core/model/site.model';
import { UserModel } from '@core/model/user.model';
import { environment } from '@env/environment';
import { CommonService } from '@shared/service/common.service';
import { ItemService } from '@shared/service/items.service';
import { ProductFamilyService } from '@shared/service/productFamily.service';
import { utiles } from '@utl/environment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProductinformationComponent } from '../productinformation/productinformation.component';
declare var $: any;

@Component({
  selector: 'app-carrusel',
  templateUrl: './carrusel.component.html',
  styleUrls: ['./carrusel.component.scss']
})
export class CarruselComponent implements OnInit, OnDestroy {

  private unsubscribe$ = new Subject<void>();
  listCarrusel: CarruselClass;
  imgDefault = environment.imgDefault;
  private userModel: UserModel;
  masterClientModel: MasterClientModel = new MasterClientModel();
  selectedClient: string;
  private siteModel: SiteModel = new SiteModel();
  private projectModel: CutsProjectModel = new CutsProjectModel();
  public sendItemModel: SendItemModel = new SendItemModel();
  userName: any;
  public imageList: ImageList[] = [];
  public vProducImage: ProductImageModel[] = [];
  public vListItems: string[];
  public vParams: string;
  public ItemId: string;
  public FamilyId: string;
  carruselName: string;
  listItem: ItemInformationModel[] = [];
  productFamilyModel: ProductFamilyModel;
  cantShopping: number;
  showCarrusel: number;
  currencyModelGeneral: any;

  @Input() tipoCarrusel: number
  @Input() familyId: string;
  @Input() custAccount: string;

  constructor(
    public itemService: ItemService,
    public router: Router,
    private common: CommonService,
    public dialog: MatDialog,
    private productFamilyService: ProductFamilyService,
  ) {

  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnInit(): void {

    if (this.tipoCarrusel === 1) {
      this.carruselName = 'Vistos recientemente'
    } else if (this.tipoCarrusel === 2) {
      this.carruselName = 'Productos en promoción'
    } else if (this.tipoCarrusel === 3) {
      this.carruselName = 'Artículos relacionados'
    } else if (this.tipoCarrusel === 4) {
      this.carruselName = 'Productos nuevos'
    }

    let data = utiles.getCacheUser();
    if (data !== null && data !== undefined) {
      this.userName = data.UserName;
      this.userModel = data;
    }
    this.common.SelectedClient.pipe(takeUntil(this.unsubscribe$))
      .subscribe(client => {
        if (client !== null) {
          this.selectedClient = '';
          this.masterClientModel = client;
        }
      });
    this.common.SelectedSite.pipe(takeUntil(this.unsubscribe$))
      .subscribe(site => {
        if (site !== null) {
          this.siteModel = site;
        }
      });
    this.common.SelectedProject.pipe(takeUntil(this.unsubscribe$))
      .subscribe(project => {
        if (project !== null) {
          this.projectModel = project;
        }
      });
    this.common.SelectedCurrency.pipe(takeUntil(this.unsubscribe$))
      .subscribe(currency => {
        if (currency !== null) {
          this.currencyModelGeneral = currency;
          this.obtenerInformacion();
        }
      });

      this.common.SelectedFamily.pipe(takeUntil(this.unsubscribe$)).subscribe(
        (family) => {
          if (family !== null && this.tipoCarrusel === 3) {
              this.productFamilyModel = family;
              this.familyId = this.productFamilyModel.FamilyId;
              this.obtenerInformacion();
          }
        }
      );

      if (this.tipoCarrusel !== 3 )
        this.obtenerInformacion();
  }

  obtenerInformacion() {
    this.listCarrusel = new CarruselClass();
    this.listCarrusel.TipoCarrusel = this.tipoCarrusel;
    this.listCarrusel.UserId = this.userModel.UserId;
    this.listCarrusel.CustAccount = this.custAccount;
    let currencyModel;

    if (this.currencyModelGeneral !== undefined && this.currencyModelGeneral !== null) {
      currencyModel = this.currencyModelGeneral;
    } else {
      currencyModel = utiles.getCacheSelectedCurrency();
    }

    if (currencyModel !== '' && currencyModel !== undefined) {
      this.listCarrusel.Currency = currencyModel.CurrencyId;
    }

    if (this.familyId !== '' && this.familyId !== undefined) {
      this.listCarrusel.Familia = this.familyId;
    } else {
      this.listCarrusel.Familia = '';
    }
    this.listCarrusel.ObtenerCarrusel(this.itemService)
     .pipe(takeUntil(this.unsubscribe$))
     .subscribe(response => {
       if (response) {
        this.listCarrusel = response[0];
        this.listItem = JSON.parse(this.listCarrusel.ItemInformation);

        if (this.listItem !== null) {
          this.showCarrusel = 1;
          this.listItem.forEach( line => {
            if (line.vImageList !== '[]') {
              if (line.vImageList.length > 0) {
                let productImage = JSON.parse(line.vImageList);
                line.ImageUrl = productImage[0].URLImage;
              } else {
                line.ImageUrl = this.imgDefault;
              }
            } else {
              line.ImageUrl = this.imgDefault;
            }
          })
        } else {
          this.showCarrusel = 0;
        }
       }
       this.carouselCards();
     })
  }

  openModalShoppingCart(item) {
    utiles.clearCacheProductShopping();

    const data = {
      itemInfo : item,
      filters: [],
      family: this.familyId
    }
    utiles.createCacheProductShopping(data);

    const dialogRef = this.dialog.open(ProductinformationComponent, {
      // panelClass: ['shopping-modal'],
      minWidth: '50vw',
      maxWidth: '90vw',
      maxHeight: '90vh',
      minHeight: '60vh',
    });

    dialogRef.componentInstance.onCancel
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((_onlyAdd) => {
        dialogRef.close();
        if (_onlyAdd === false) {
          this.router.navigate(['shoppingcart']);
        }
      });
  }

  carouselCards() {
    let that = this;
    $(document).ready(function() {
      $('.carousel.carousel-lastOffers .carousel-item').each(function() {
        var next = $(this).next();
        if (!next.length) {
          next = $(this).siblings(':first');
        }

        if(that.listItem !== null && that.listItem !== undefined) {
          if (that.listItem.length <= 1) {
          } else if (that.listItem.length === 2) {
            next.children(':first-child').clone().appendTo($(this));

            for (var i = 0; i < 0; i++) {
              next = next.next();
              if (!next.length) {
                next = $(this).siblings(':first');
              }

              next.children(':first-child').clone().appendTo($(this));
            }
          } else if (that.listItem.length === 3) {
            next.children(':first-child').clone().appendTo($(this));

            for (var i = 0; i < 1; i++) {
              next = next.next();
              if (!next.length) {
                next = $(this).siblings(':first');
              }

              next.children(':first-child').clone().appendTo($(this));
            }
          } else if (that.listItem.length >= 4) {
            next.children(':first-child').clone().appendTo($(this));

            for (var i = 0; i < 2; i++) {
              next = next.next();
              if (!next.length) {
                next = $(this).siblings(':first');
              }

              next.children(':first-child').clone().appendTo($(this));
            }
          }
        }
      });

      $('.recently').click(function(e) {

        if (that.listItem !== null) {
          that.listItem.forEach(entry => {
            if (entry.ItemId === e.currentTarget.name) {
              let item = { ItemId: e.currentTarget.name };
              if (entry.Favorite === 1) {
                that.deleteFavorite(item);
                e.currentTarget.children[0].innerHTML = 'favorite_border';
                e.currentTarget.children[0].innerText = 'favorite_border';
              } else {
                that.addFavorite(item);
                e.currentTarget.children[0].innerHTML = 'favorite';
                e.currentTarget.children[0].innerText = 'favorite';
              }
            }
          });
        }
      });
      $('.recently2').click(function(e) {
        if (that.listItem !== null) {
          that.listItem.forEach(entry => {
            if (entry.ItemId === e.currentTarget.name) {
              let item = { ItemId: e.currentTarget.name };
              if (entry.Favorite === 1) {
                that.deleteFavorite(item);
                e.currentTarget.children[0].innerHTML = 'favorite_border';
                e.currentTarget.children[0].innerText = 'favorite_border';
              } else {
                that.addFavorite(item);
                e.currentTarget.children[0].innerHTML = 'favorite';
                e.currentTarget.children[0].innerText = 'favorite';
              }
            }
          });
        }
      });
      $('.recently3').click(function(e) {
        if (that.listItem !== null) {
          that.listItem.forEach(entry => {
            if (entry.ItemId === e.currentTarget.name) {
              let item = { ItemId: e.currentTarget.name };
              if (entry.Favorite === 1) {
                that.deleteFavorite(item);
                e.currentTarget.children[0].innerHTML = 'favorite_border';
                e.currentTarget.children[0].innerText = 'favorite_border';
              } else {
                that.addFavorite(item);
                e.currentTarget.children[0].innerHTML = 'favorite';
                e.currentTarget.children[0].innerText = 'favorite';
              }
            }
          });
        }
      });
      $('.recently4').click(function(e) {
        if (that.listItem !== null) {
          that.listItem.forEach(entry => {
            if (entry.ItemId === e.currentTarget.name) {
              let item = { ItemId: e.currentTarget.name };
              if (entry.Favorite === 1) {
                that.deleteFavorite(item);
                e.currentTarget.children[0].innerHTML = 'favorite_border';
                e.currentTarget.children[0].innerText = 'favorite_border';
              } else {
                that.addFavorite(item);
                e.currentTarget.children[0].innerHTML = 'favorite';
                e.currentTarget.children[0].innerText = 'favorite';
              }
            }
          });
        }
      });
      $('.product-image-card').click(function(e) {

        let itemId = e.currentTarget.name;
        that.goToDetailProduct(itemId);
      });
      $('.product-name-card').click(function(e) {

        let itemId = e.currentTarget.name;
        that.goToDetailProduct(itemId);
      });
      $('.shoppin-cart-card-carrusel').click(function(e) {
        this.cantShopping = 1;

        this.vListItems = [];
        this.vParams = '';
        this.ItemId = '';
        this.FamilyId = '';
        this.vParams = e.currentTarget.name;
        this.vListItems = this.vParams.split(',', 2);

        this.ItemId   = this.vListItems[0];
        this.FamilyId = this.vListItems[1];
        this.FamilyId = this.FamilyId.replace(/\s/g, '');
        let type = this.tipoCarrusel;
        if (that.listItem !== null) {
          that.listItem.forEach(entry => {
            if (entry.ItemId === this.ItemId && this.cantShopping === 1) {

              let shoppingData = utiles.getCacheProductShopping();
              if (shoppingData !== '' && shoppingData !== undefined) {
                if (shoppingData.itemInfo.ItemId !== this.ItemId) {
                  let item = { ItemId: this.ItemId, FamilyId: this.FamilyId };
                  that.openModalShoppingCart(item);
                  this.cantShopping = 2;
                }
              } else {
                let item = { ItemId: this.ItemId, FamilyId: this.FamilyId };
                that.openModalShoppingCart(item);
                this.cantShopping = 2;
              }
            }
          });
        }
      });
    });
  }

  goToDetailProduct(itemId) {
    let filters = [];
    let searchProd = {
      Family: this.FamilyId,
      SearchWord: '',
      SelectedFilters: filters,
    };

    this.router.navigate(['productdetail'], {
      queryParams: {
        ItemId: itemId,
        searchProd: JSON.stringify(searchProd),
      },
    });
  }

  deleteFavorite(item) {

    this.sendItemModel.UserId = this.userModel.UserId;
    this.sendItemModel.ItemId = item.ItemId;
    this.productFamilyService.deleteFromFavorite(this.sendItemModel)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        response => {
          if (response) {
          }
        },
      );
  }
  addFavorite(item) {
    this.sendItemModel.UserId = this.userModel.UserId;
    this.sendItemModel.ItemId = item.ItemId;
    this.productFamilyService.addToFavoriteItems(this.sendItemModel)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        response => {
          if (response) {
          }
        },
      );
  }

}
